import React from "react";

export const ClearIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="31" fillRule="nonzero" fill="#3F4447">
                <g transform="translate(08.000000, 04.000000)">
                    <path
                        d="M48.383 3.73c2.38.354 2.74 3.636.494 4.499-10.404 3.996-17.428 14.095-17.428 25.53 0 15.085 12.11 27.305 27.04 27.305 3.64 0 7.175-.725 10.456-2.116 2.218-.94 4.239 1.681 2.764 3.587-6.846 8.85-17.334 14.132-28.684 14.132C22.94 76.667 6.668 60.246 6.668 40c0-20.246 16.273-36.666 36.358-36.666 1.805 0 3.594.132 5.358.395zM11.347 40c0 17.67 14.188 31.986 31.678 31.986 7.03 0 13.679-2.326 19.08-6.447-1.193.137-2.4.206-3.617.206-17.523 0-31.72-14.325-31.72-31.986A32.073 32.073 0 0139.375 8.224C23.603 10.052 11.347 23.577 11.347 40z"
                        fill="#717277"
                    />
                </g>
            </g>
        </g>
    </svg>
);
